import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeDocumentTypeCommand extends BaseCommand {
  CommandName = "ChangeDocumentType";
  Command: { Value: number };
  constructor(sessionId: string, operationId: string, value: number) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
